import { useCallback } from 'react';

interface Props {
  ocasionesPreferidas: string[];
  setOcasionesPreferidas: (v: string[] | ((prev: string[]) => string[])) => void;
}

const OCASIONES_OPCIONES = [
  'Trabajo / Oficina', 'Eventos formales', 'Eventos informales',
  'Viajes', 'Citas / Salidas', 'Fines de semana casuales',
  'Bodas / Celebraciones', 'Temporada de invierno',
  'Temporada de verano', 'Transición entretiempo',
];

export default function OcasionesSection({ ocasionesPreferidas, setOcasionesPreferidas }: Props) {
  const toggleOcasion = useCallback((ocasion: string) => {
    setOcasionesPreferidas((prev) =>
      prev.includes(ocasion) ? prev.filter((o) => o !== ocasion) : [...prev, ocasion]
    );
  }, [setOcasionesPreferidas]);

  return (
    <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-brand-sage/20 flex items-center justify-center text-brand-black">
          <i className="ri-calendar-check-line text-lg" />
        </div>
        <div>
          <h3 className="font-serif text-brand-black text-lg font-medium">Ocasiones preferidas</h3>
          <p className="font-sans text-brand-gray-500 text-xs mt-0.5">
            Selecciona para qué momentos el cliente suele vestirse
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {OCASIONES_OPCIONES.map((ocasion) => {
          const selected = ocasionesPreferidas.includes(ocasion);
          return (
            <label
              key={ocasion}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition-all ${
                selected
                  ? 'border-brand-black bg-brand-black/5'
                  : 'border-brand-gray-200 hover:border-brand-gray-400'
              }`}
            >
              <input
                type="checkbox"
                checked={selected}
                onChange={() => toggleOcasion(ocasion)}
                className="w-4 h-4 accent-brand-black cursor-pointer shrink-0"
              />
              <span className={`font-sans text-sm ${selected ? 'text-brand-black font-medium' : 'text-brand-gray-600'}`}>
                {ocasion}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}